import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { RakutenMobile } from '@travel/icons/service';
import { Checkmark } from '@travel/icons/ui';
import { Translate } from '@travel/translation';
import { FlatButton } from '@travel/ui';

import { fetchCouponList } from 'store/rakutenMobile/actions';

import { CouponStatus } from 'constants/reservations';

import styles from './rakutenMobile.module.scss';

type Props = {
  mobileCouponStatus: CouponStatus;
  reservationId: string;
};

const RakutenMobileButton = (props: Props) => {
  const { mobileCouponStatus, reservationId } = props;
  const dispatch = useDispatch();
  const handleClick = useCallback(() => {
    dispatch(fetchCouponList({ reservationId }));
  }, [dispatch, reservationId]);
  const isDisabled = mobileCouponStatus === CouponStatus.DISABLE;
  const isApplicable = mobileCouponStatus === CouponStatus.APPLICABLE;
  return (
    <>
      {isApplicable || isDisabled ? (
        <>
          <FlatButton
            classType="rakutenMobile"
            className={styles.button}
            onClick={handleClick}
            isDisabled={isDisabled}
          >
            <RakutenMobile
              size={20}
              className={styles.icon}
              color={isDisabled ? 'pastelGray' : 'white'}
            />
            <Translate id="Booking_List.Reservation_Summary.Mobile_Coupon.Use_Coupon" />
          </FlatButton>
          <p className={styles.notice}>
            <Translate id="Booking_List.Reservation_Summary.Mobile_Coupon.Explanation" />
          </p>
        </>
      ) : (
        <>
          <p className={styles.applied}>
            <Checkmark size={16} className={styles.icon} />
            <Translate id="Booking_List.Reservation_Summary.Mobile_Coupon.Message.Coupon_Applied" />
          </p>
        </>
      )}
    </>
  );
};
export default RakutenMobileButton;
